import { AirdropSelectMembersPageTemplate } from "./template";
import { useAirdropSelectMembersPage } from "./logic";

export const AirdropSelectMembersPage = () : JSX.Element => {
    const props = useAirdropSelectMembersPage();

    return (
        <AirdropSelectMembersPageTemplate {...props}/>
    )
}